import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Angemeldet zu sein reicht nicht. Der BFF weist ein Konto ohne bestaetigte
// Adresse ab, und wer trotzdem hereinkam, sah nur Seiten, die auf ein
// ThingsBoard-Token warteten, das nie kam — das war das "laden…", das nie
// aufhoerte. Deshalb haengt der Durchlass an isReady: angemeldet UND
// eingerichtet. Alles andere geht zurueck auf /login, das den Grund nennt.
//
// Der Zustand wird hier geholt statt durchgereicht: Sonst muesste jede der
// rund zwanzig Routen ihn einzeln weitergeben, und eine vergessene faellt
// niemandem auf.
function ProtectedRoute({ children }) {
  const { isReady } = useAuth();
  const location = useLocation();

  if (!isReady) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}

export default ProtectedRoute;
